import React, { useContext } from "react";
import { SetPasswordContext } from "../SetPasswordView";
import LoginLogo from "../../../assets/images/clsm-logo.svg";

import "./setPage.css";
import ThemeInput from "../../../components/ThemeInput/ThemeInput";
import ThemeButton from "../../../components/ThemeButton/ThemeButton";
import EyeOpen from "../../../assets/images/icons/password-show.svg";
import EyeClose from "../../../assets/images/icons/password-hide.svg";
import Loader from "../../../components/Loader/Loader";
import PopupAlert from "../../../components/PopupAlertSuccess/PopupAlert";
import PopupAlertError from "../../../components/PopupAlertError/PopupAlertError";
import LinkExpired from "../../../assets/images/404img.png";

const SetPasswordPage = () => {
  const {
    passwordType,
    toggleEyeIcon,
    confirmPasswordType,
    toggleEyeIconConfirm,
    pageContent,
    spinnerStatus,
    resetError,
    errorAlertMessage,
    errorAlertShow,
    setErrorAlertShow,
    submitnewPasswordapi,
    statusCode,
    password,
    handleConfirmPasswordChange,
    pageToForgotpassword,
    handlePasswordChange,
    passwordValidateMsg,
    confirmPassword,
    handleSucessClose,
    successMessage,
    successModal,
    validateResetToken,
  } = useContext(SetPasswordContext);

  return (
    // main div starts

    <div className="resetPasswordPage">
      {spinnerStatus && <Loader />}
      {validateResetToken ? (
        <div className="resetPasswordPage loginPage">
          <div className="loginLogo">
            <div className="loginLeft"></div>
          </div>
          <div className="loginEnter">
            <div className="flexContentData">
              <h3>
                <img src={LoginLogo} alt="logo" />
              </h3>

              <p className="mb-2 formSubTitle">
                {pageContent.setPasswordTitle}
              </p>
              <p className="mb-3 subTitleLogin">
                {pageContent.resetPasswordSubTitle}
              </p>
              <form onSubmit={submitnewPasswordapi}>
                {/* Email Input starts*/}
                <label className="input-label mt-4 mb-1">
                  {pageContent.newPasswordLabel}
                </label>
                <div className="icon-input">
                  <ThemeInput
                    placeholder={pageContent.newPasswordPlaceholder}
                    type={passwordType}
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <span className="eye-icon" onClick={toggleEyeIcon}>
                    {passwordType === "password" ? (
                      <img src={EyeOpen} alt="Eye-open" />
                    ) : (
                      <img src={EyeClose} alt="Eye-close" />
                    )}
                  </span>
                </div>
                <p className="mb-0 error-msg">{resetError ? resetError : ""}</p>
                {/* Email Input ends*/}

                {/* password input starts */}
                <label className="input-label mt-3 mb-1">
                  {pageContent.confirmPasswordLabel}
                </label>
                <div className="icon-input">
                  <ThemeInput
                    placeholder={pageContent.confirmPasswordPlaceholder}
                    type={confirmPasswordType}
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                  />
                  <span className="eye-icon" onClick={toggleEyeIconConfirm}>
                    {confirmPasswordType === "password" ? (
                      <img src={EyeOpen} alt="Eye-open" />
                    ) : (
                      <img src={EyeClose} alt="Eye-close" />
                    )}
                  </span>
                </div>
                <p className="mb-0 error-msg">
                  {passwordValidateMsg ? passwordValidateMsg : ""}
                </p>
                {/* password input ends */}

                {/* submit button */}
                <ThemeButton
                  value={pageContent.submitText}
                  id="reSubmitbtns"
                  className="mt-5"
                  type="submit"
                />
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="expiryLinkPage">
          <div className="linkExpiryImage">
            <img src={LinkExpired} alt="expiry img" />
          </div>
          <div className="expiryContent">
            <h4>{pageContent.linkExpiredText}</h4>
            <h6>{pageContent.wrongMessgae}</h6>
            <div className="goHomeBtn mt-4" onClick={handleSucessClose}>
              {pageContent.linkBtnName}
            </div>
          </div>
        </div>
      )}
      <PopupAlert
        show={successModal}
        alertMessage={successMessage}
        handleSubmit={handleSucessClose}
      />
      <PopupAlertError
        status={statusCode}
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        buttonText={pageContent.tryAgain}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          setErrorAlertShow(false);
          document.getElementById("reSubmitbtns").click();
        }}
      />
    </div>

    // main div end
  );
};

export default SetPasswordPage;
